@if (thumbnailUrl(); as url) {
	<span
		[tuiAvatar]="icon()"
		class="media-thumbnail__avatar"
		size="l"
		[round]="false"
	>
		<img [src]="url" alt="" />
	</span>
} @else {
	<span
		[tuiAvatar]="icon()"
		class="media-thumbnail__avatar"
		size="l"
		[round]="false"
	></span>
}

@if (badgeIcon()) {
	<span
		[tuiAvatar]="badgeIcon()"
		class="media-thumbnail__badge"
		size="s"
		tuiHintAppearance="dark"
		[tuiHint]="badgeHint()"
	></span>
}
